import { Log } from '@ainova/core';
import { ReportingService } from './service';
import { env } from '$lib/config/environment';

/**
 * Mock adapter for the reporting service that logs to the console.
 */
export class ReportingServiceMock extends ReportingService {
  private logger = new Log('ReportingMock');

  async error(message: string, context?: Record<string, unknown>): Promise<void> {
    if (env.features.debugging) {
      this.logger.error(message, context);
    }
  }

  async warning(message: string, context?: Record<string, unknown>): Promise<void> {
    if (env.features.debugging) {
      this.logger.warn(message, context);
    }
  }

  async info(message: string, context?: Record<string, unknown>): Promise<void> {
    if (env.features.debugging) {
      this.logger.info(message, context);
    }
  }
}
